
export const GlobalConfig = {
    tenant: "common",
    featureFlags: {
      atlasSftpIntegration: false,
      aps: false,
      notices: false,
      auQnrs: false,
      auRobots: false,
      questionnaireRequiredTaxReturn: true,
      skipGenerationIfNoChange: false,
      syncPackageGeneration: false,
      requireClientApproval: false,
      selectPackageTemplates: false,
      amendmentRevisionCount: false,
      sourceUploadAppendOrReplace: false,
      checkUnsignedDocs: false,
      addSpouseRequireTaxId: false,
      taxReturnBulkAction: false,
      bulkTaxReturnStatusUpdate: false,
      moveAssigneeToDifferentClient: true,
      bulkMoveAssigneeToPopulation: false,
      displayModernTableAsDefault: false,
      preparerCanReturnBackForChanges: false,
      closeTaxReturn: true,
    },
};
